export default __webpack_public_path__ + "static/media/bg1.eab9bdf8.png";